import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import classNames from "classnames";
import Button from "../../Button";
import Divider from "../Divider";
import style from "./style.module.scss";
export default function FilterPanel(props) {
    const { title, removable, onRemove, onDone, children } = props;
    const ref = useRef(null);
    function onRemoveHandler() {
        if (onRemove) {
            onRemove();
        }
    }
    const onDoneHandler = () => {
        if (onDone) {
            onDone();
        }
    };
    return (_jsxs("div", { className: classNames(style["filter-panel"], "qa-filter-panel"), ref: ref, children: [title ? _jsx("div", { className: style["filter-panel__title"], children: title }) : null, _jsx(Divider, {}), _jsx("div", { className: style["filter-panel__body"], children: children }), _jsx(Divider, {}), _jsxs("div", { className: style["filter-panel__footer"], children: [_jsx(Button, { onClick: onDoneHandler, variation: "secondary", children: "Done" }), removable ? (_jsx(Button, { onClick: onRemoveHandler, variation: "primary-inline", children: "Remove Filter" })) : null] })] }));
}
